import { useAuth } from '../context/AuthContext';
import GuestRoutes from './GuestRoutes';
import UserRoutes from './UserRoutes';
import DoctorRoutes from './DoctorRoutes';
import NotVerifiedRoutes from './NotVerifiedRoutes';

export default function AppNavigator() {
  const { user, doctor } = useAuth();

  if (doctor !== null) {
    return <DoctorRoutes />;
  }

  if (user && user.verified === true) {
    return <UserRoutes />;
  }

  if (user && user.verified === false) {
    return <NotVerifiedRoutes />;
  }

  return <GuestRoutes />;
}
